(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-search-module"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var CFG = window.FF_CONFIG || {};
    var SHOP = CFG.shopUrl || '';
    var W_COL = (CFG.waterCollectionHandle || '').trim();
    var A_COL = (CFG.airCollectionHandle || '').trim();
    /* ─── Navigate to selected brand collection ─── */
    function ffGoToBrandCollection(selectId) {
      var sel = document.getElementById(selectId);
      if (!sel || !sel.value) return;
      window.location.href = sel.value;
    }

    function ffGoToCollectionUrl(url) {
      url = (url || '').trim();
      if (!url) return;
      window.location.href = url;
    }

    /* ─── Render helpers ─── */
    function ffSetLoading(containerId) {
      var el = document.getElementById(containerId);
      if (!el) return;
      el.className = 'ff-results ff-results--visible';
      el.innerHTML = '<div class="ff-loading"><span class="ff-spinner"></span>Searching&hellip;</div>';
    }

    function ffSetDisabled(btnId, state) {
      var btn = document.getElementById(btnId);
      if (btn) btn.disabled = state;
    }

    function ffShowMessage(containerId, message) {
      var el = document.getElementById(containerId);
      if (!el) return;
      el.className = 'ff-results ff-results--visible';
      el.innerHTML = '<p class="ff-no-results">' + message + '</p>';
    }

    function ffFilterProductsByTitle(products, query) {
      var lc = query.toLowerCase();
      return (products || []).filter(function (p) {
        return p.title && p.title.toLowerCase().indexOf(lc) !== -1;
      });
    }

    function ffPickBestTitleMatch(matches, query) {
      var lc = query.toLowerCase();
      matches.sort(function (a, b) {
        var at = a.title.toLowerCase();
        var bt = b.title.toLowerCase();
        var score = function (title) {
          if (title === lc) return 0;
          if (title.indexOf(lc) === 0) return 1;
          return 2;
        };
        var diff = score(at) - score(bt);
        if (diff !== 0) return diff;
        return at.length - bt.length;
      });
      return matches[0];
    }

    function ffFilterProductsBySize(products, patterns) {
      return (products || []).filter(function (p) {
        var title = (p.title || '').toLowerCase();
        return patterns.some(function (pat) {
          return title.indexOf(pat.toLowerCase()) !== -1;
        });
      });
    }

    function ffPickBestSizeMatch(matches, w, h, t) {
      var primary = (w + 'x' + h + 'x' + t).toLowerCase();
      var spaced = (w + ' x ' + h + ' x ' + t).toLowerCase();
      matches.sort(function (a, b) {
        var at = a.title.toLowerCase();
        var bt = b.title.toLowerCase();
        var score = function (title) {
          if (title.indexOf(primary) !== -1) return 0;
          if (title.indexOf(spaced) !== -1) return 1;
          return 2;
        };
        var diff = score(at) - score(bt);
        if (diff !== 0) return diff;
        return at.length - bt.length;
      });
      return matches[0];
    }

    /* ─────────────────────────────────────────────────────────
     Collection products — /collections/{handle}/products.json
     Paginates when limit=250 so large collections are fully searched.
  ───────────────────────────────────────────────────────── */
    function ffFetchCollection(collectionHandle, callback) {
      var all = [];
      var page = 1;

      function fetchPage() {
        var url = SHOP + '/collections/' + collectionHandle + '/products.json?limit=250&page=' + page;
        fetch(url)
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var batch = data.products || [];
            all = all.concat(batch);
            if (batch.length === 250) {
              page += 1;
              fetchPage();
            } else {
              callback(null, all);
            }
          })
          .catch(function (err) {
            callback(err, all);
          });
      }

      fetchPage();
    }

    /* Size patterns for title matching, e.g. "20x25x1" or "20 x 25 x 1" */
    function ffBuildSizePatterns(w, h, t) {
      /* Build several notation variants found in product titles */
      var combos = [
        [w, h],
        [h, w] /* both orientations */,
      ];
      var sep = ['x', 'X', ' x ', ' X ', '×'];
      var patterns = [];
      combos.forEach(function (pair) {
        sep.forEach(function (s) {
          patterns.push(pair[0] + s + pair[1] + s + t);
          patterns.push(pair[0] + '"' + s + pair[1] + '"' + s + t + '"');
          patterns.push(pair[0] + s + pair[1] + s + t + '"');
        });
      });
      return patterns;
    }

    /* ─── Water: part # search (title match in water collection → product page) ─── */
    function ffSearchWaterByPart() {
      var q = (document.getElementById('ff-water-part-input').value || '').trim();
      if (!q) return;

      if (!W_COL) {
        ffShowMessage(
          'ff-water-results',
          'Water filter collection is not set. Choose a collection in the theme editor to enable part # search.'
        );
        return;
      }

      ffSetLoading('ff-water-results');
      ffSetDisabled('ff-water-part-btn', true);

      ffFetchCollection(W_COL, function (err, products) {
        ffSetDisabled('ff-water-part-btn', false);
        if (err) {
          ffShowMessage('ff-water-results', 'Unable to search right now. Please try again.');
          return;
        }

        var matches = ffFilterProductsByTitle(products, q);
        if (!matches.length) {
          ffShowMessage(
            'ff-water-results',
            'No matching products found in this collection. Try a different part # or model #.'
          );
          return;
        }

        var best = ffPickBestTitleMatch(matches, q);
        window.location.href = SHOP + '/products/' + best.handle;
      });
    }

    /* ─── Air: size search (title match in air collection → product page) ─── */
    function ffSearchAirBySize() {
      var w = (document.getElementById('ff-air-w').value || '').trim();
      var h = (document.getElementById('ff-air-h').value || '').trim();
      var t = document.getElementById('ff-air-thick').value;
      if (!w || !h) return;

      if (!A_COL) {
        ffShowMessage(
          'ff-air-results',
          'Air filter collection is not set. Choose a collection in the theme editor to enable size search.'
        );
        return;
      }

      ffSetLoading('ff-air-results');
      ffSetDisabled('ff-air-size-btn', true);

      var patterns = ffBuildSizePatterns(w, h, t);

      ffFetchCollection(A_COL, function (err, products) {
        ffSetDisabled('ff-air-size-btn', false);
        if (err) {
          ffShowMessage('ff-air-results', 'Unable to search right now. Please try again.');
          return;
        }

        var matches = ffFilterProductsBySize(products, patterns);
        if (!matches.length) {
          ffShowMessage('ff-air-results', 'No matching products found in this collection. Try a different size.');
          return;
        }

        var best = ffPickBestSizeMatch(matches, w, h, t);
        window.location.href = SHOP + '/products/' + best.handle;
      });
    }

    /* ─── Init ─── */
    function ffInit() {
      /* Water part # */
      var wPartBtn = document.getElementById('ff-water-part-btn');
      if (wPartBtn) wPartBtn.addEventListener('click', ffSearchWaterByPart);

      var wPartInput = document.getElementById('ff-water-part-input');
      if (wPartInput)
        wPartInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') ffSearchWaterByPart();
        });

      /* Water brand → collection page */
      var wBrandBtn = document.getElementById('ff-water-brand-btn');
      if (wBrandBtn)
        wBrandBtn.addEventListener('click', function () {
          ffGoToBrandCollection('ff-water-brand-select');
        });

      /* Air size */
      var aBtn = document.getElementById('ff-air-size-btn');
      if (aBtn) aBtn.addEventListener('click', ffSearchAirBySize);

      ['ff-air-w', 'ff-air-h'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el)
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') ffSearchAirBySize();
          });
      });

      /* Air brand → collection page */
      var aBrandBtn = document.getElementById('ff-air-brand-btn');
      if (aBrandBtn)
        aBrandBtn.addEventListener('click', function () {
          ffGoToBrandCollection('ff-air-brand-select');
        });

      /* Quick brand buttons → collection page */
      document.querySelectorAll('.ff-brand-btn[data-collection-url]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          ffGoToCollectionUrl(btn.getAttribute('data-collection-url'));
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ffInit);
    } else {
      ffInit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
